/* Vinted-inspired theme — interactions */
(function () {
  'use strict';

  /* ---------- Security helpers ----------
     escapeHtml(): neutralises HTML metacharacters before any value is placed
     into innerHTML. Use for ALL dynamic text (search terms, product titles,
     vendor names, prices, and anything returned by a third-party endpoint).

     safeUrl(): allows only http(s)/mailto/tel and root-relative or
     protocol-relative URLs, blocking javascript: and data: vectors before a
     value is used in href/src. Returns '#' for anything suspicious. */
  function escapeHtml(value) {
    if (value == null) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function safeUrl(value) {
    if (value == null) return '#';
    var url = String(value).trim();
    if (url === '') return '#';
    // Allow root-relative (/...), protocol-relative (//...), and anchors (#...)
    if (/^(\/(?!\/)|#|\/\/)/.test(url) || url.indexOf('/') === 0) {
      // still escape quotes/brackets so the value can't break out of the attribute
      return escapeHtml(url);
    }
    // Allow only explicit safe schemes
    if (/^(https?:|mailto:|tel:)/i.test(url)) {
      return escapeHtml(url);
    }
    // Reject javascript:, data:, vbscript:, and anything else
    return '#';
  }
  // Expose for any inline callers / future sections
  window.themeEscapeHtml = escapeHtml;
  window.themeSafeUrl = safeUrl;

  /* ---------- Mobile drawer ---------- */
  function setupDrawer() {
    var burger = document.querySelector('[data-drawer-open]');
    var drawer = document.querySelector('[data-drawer]');
    var backdrop = document.querySelector('[data-drawer-backdrop]');
    var closeBtn = document.querySelector('[data-drawer-close]');
    if (!drawer) return;
    function open() { drawer.classList.add('is-open'); if (backdrop) backdrop.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); if (backdrop) backdrop.classList.remove('is-open'); document.body.style.overflow = ''; }
    if (burger) burger.addEventListener('click', function (e) {
      // If the store chose the Browse panel as the mobile menu, open that instead
      var style = document.body.getAttribute('data-mobile-menu-style');
      if (style === 'browse' && typeof window.openBrowsePanel === 'function') {
        e.preventDefault();
        window.openBrowsePanel();
      } else {
        open();
      }
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    window.openDrawer = open;
  }

  /* ---------- Accordions ---------- */
  function setupAccordions() {
    document.querySelectorAll('.accordion__head').forEach(function (head) {
      head.addEventListener('click', function () {
        head.closest('.accordion__item').classList.toggle('is-open');
      });
    });
  }

  /* ---------- Product gallery thumbs ---------- */
  function setupGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var items = gallery.querySelectorAll('[data-media-item]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!thumbs.length) return;

    function show(id) {
      items.forEach(function (item) {
        var match = item.getAttribute('data-media-id') === id;
        item.classList.toggle('is-active', match);
        // Pause any video/iframe that is being hidden
        if (!match) {
          var vid = item.querySelector('video');
          if (vid) { try { vid.pause(); } catch (e) {} }
          var iframe = item.querySelector('iframe');
          if (iframe) { var s = iframe.src; iframe.src = s; } // reload to stop playback
        }
      });
      thumbs.forEach(function (t) { t.classList.toggle('active', t.getAttribute('data-media-id') === id); });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.getAttribute('data-media-id')); });
    });

    // Thumbnail slider arrows (when enabled and >6 thumbs)
    var wrap = gallery.querySelector('[data-thumbs-wrap]');
    var track = gallery.querySelector('[data-thumbs-track]');
    var prev = gallery.querySelector('[data-thumb-prev]');
    var next = gallery.querySelector('[data-thumb-next]');
    if (track && prev && next) {
      function step() {
        var t = track.querySelector('.product__thumb');
        var h = t ? t.offsetHeight : 80;
        return (h + 10) * 3; // scroll ~3 thumbs at a time
      }
      function updateArrows() {
        prev.disabled = track.scrollTop <= 2;
        next.disabled = track.scrollTop + track.clientHeight >= track.scrollHeight - 2;
      }
      prev.addEventListener('click', function () { track.scrollTop -= step(); });
      next.addEventListener('click', function () { track.scrollTop += step(); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
      // Re-check after thumbnails finish loading (scrollHeight changes)
      window.addEventListener('load', updateArrows);
      setTimeout(updateArrows, 400);
    }
  }

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var fmt = window.themeMoneyFormat || '${{amount}}';
    function withCommas(decimals) {
      var v = (cents / 100).toFixed(decimals);
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return withCommas(2);
        case 'amount_no_decimals': return withCommas(0);
        case 'amount_with_comma_separator': return withCommas(2).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(0).replace('.', ',');
        default: return withCommas(2);
      }
    });
  }

  /* ---------- Variant selection ---------- */
  function setupVariants() {
    var form = document.querySelector('[data-product-form]');
    var dataEl = document.querySelector('[data-product-variants]');
    if (!form || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var gallery = document.querySelector('[data-gallery]');
    var buyArea = document.querySelector('[data-buy]');
    var oosImg = document.querySelector('[data-oos-image]');

    function currentOptions() {
      return selects.map(function (s) { return s.value; });
    }

    function update() {
      var chosen = currentOptions();
      var match = variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;

      if (idInput) idInput.value = match.id;

      if (priceEl) priceEl.textContent = match.price_money || formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = match.compare_at_price_money || formatMoney(match.compare_at_price);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }

      if (gallery && match.media_id) {
        var targetId = String(match.media_id);
        var found = gallery.querySelector('[data-media-item][data-media-id="' + targetId + '"]');
        if (found) {
          gallery.querySelectorAll('[data-media-item]').forEach(function (it) {
            it.classList.toggle('is-active', it === found);
          });
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('active', t.getAttribute('data-media-id') === targetId);
          });
        }
      }

      if (buyArea) {
        var primary = buyArea.querySelectorAll('button[name="checkout"], button[name="add"]');
        primary.forEach(function (b) {
          if (match.available) { b.removeAttribute('disabled'); }
          else { b.setAttribute('disabled', ''); }
        });
      }

      // Show the custom out-of-stock image when the chosen variant is sold out
      if (oosImg) {
        if (match.available) { oosImg.setAttribute('hidden', ''); }
        else { oosImg.removeAttribute('hidden'); }
      }

      // Update the sticky add-to-cart thumbnail to the variant image
      var stickyImg = document.querySelector('[data-sticky-img]');
      if (stickyImg && match.image) { stickyImg.src = match.image; }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  /* ---------- Product design 2: swatch radios → hidden selects ---------- */
  function setupPd2Swatches() {
    var form = document.querySelector('.pd2__form[data-product-form]');
    if (!form) return;
    var mirrors = form.querySelectorAll('select[data-pd2-mirror]');
    if (!mirrors.length) return;

    form.querySelectorAll('[data-pd2-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var idx = parseInt(radio.getAttribute('data-pd2-index'), 10);
        var sel = mirrors[idx];
        if (sel) {
          sel.value = radio.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // active swatch styling within this group
        var group = radio.closest('.pd2__swatches');
        if (group) group.querySelectorAll('.pd2__swatch').forEach(function (s) {
          s.classList.toggle('is-active', s.contains(radio));
        });
        // update the "Option: value" display
        var disp = form.querySelector('[data-opt-display="' + idx + '"]');
        if (disp) disp.textContent = radio.value;
      });
    });
  }

  /* ---------- Click-to-zoom lightbox ---------- */
  function setupZoom() {
    var triggers = document.querySelectorAll('[data-zoom]');
    if (!triggers.length) return;
    var firstTrigger = triggers[0];

    // Build the gallery list from all image media items.
    function collectImages() {
      var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-media-item][data-media-type="image"] img'));
      if (imgs.length) {
        return imgs.map(function (im) { return im.getAttribute('data-zoom-src') || im.src; });
      }
      var main = firstTrigger.querySelector('img');
      return main ? [main.getAttribute('data-zoom-src') || main.src] : [];
    }

    var overlay = document.createElement('div');
    overlay.className = 'zoom-overlay';
    overlay.innerHTML =
      '<button class="zoom-overlay__close" aria-label="Close">&times;</button>' +
      '<button class="zoom-overlay__nav zoom-overlay__prev" aria-label="Previous image">&#8249;</button>' +
      '<img alt="">' +
      '<button class="zoom-overlay__nav zoom-overlay__next" aria-label="Next image">&#8250;</button>' +
      '<div class="zoom-overlay__counter" aria-hidden="true"></div>';
    document.body.appendChild(overlay);

    var overlayImg = overlay.querySelector('img');
    var prevBtn = overlay.querySelector('.zoom-overlay__prev');
    var nextBtn = overlay.querySelector('.zoom-overlay__next');
    var counter = overlay.querySelector('.zoom-overlay__counter');

    var images = [];
    var index = 0;

    function show(i) {
      if (!images.length) return;
      index = (i + images.length) % images.length; // wrap around
      overlayImg.src = images[index];
      var multi = images.length > 1;
      prevBtn.style.display = multi ? '' : 'none';
      nextBtn.style.display = multi ? '' : 'none';
      counter.style.display = multi ? '' : 'none';
      counter.textContent = (index + 1) + ' / ' + images.length;
    }

    function open(startSrc) {
      images = collectImages();
      if (!images.length) return;
      var start = 0;
      if (startSrc) {
        var idx = images.indexOf(startSrc);
        if (idx >= 0) start = idx;
      } else {
        var activeThumb = document.querySelector('[data-gallery-thumb].active');
        var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
        var ti = activeThumb ? thumbs.indexOf(activeThumb) : 0;
        start = ti < 0 ? 0 : ti;
      }
      show(start);
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    function prev() { show(index - 1); }
    function next() { show(index + 1); }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var im = trigger.querySelector('img');
        open(im ? (im.getAttribute('data-zoom-src') || im.src) : null);
      });
    });

    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); });
    overlayImg.addEventListener('click', function (e) { e.stopPropagation(); }); // don't close when clicking the photo
    overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') prev();
      else if (e.key === 'ArrowRight') next();
    });

    // Swipe on touch devices
    var startX = null;
    overlay.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); }
      startX = null;
    });
  }

  /* ---------- Quantity steppers (cart) ---------- */
  function setupQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      function change(delta) {
        var v = parseInt(input.value, 10) || 1;
        v = Math.max(1, v + delta);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (minus) minus.addEventListener('click', function () { change(-1); });
      if (plus) plus.addEventListener('click', function () { change(1); });
    });
  }

  /* ---------- Card hover video ---------- */
  function setupCardHoverVideo() {
    document.querySelectorAll('.card--hover-media').forEach(function (card) {
      var video = card.querySelector('[data-card-video]');
      if (!video) return;
      card.addEventListener('mouseenter', function () {
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      });
      card.addEventListener('mouseleave', function () {
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      });
    });
  }

  /* ---------- Mobile search toggle ---------- */
  function setupMobileSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var header = document.querySelector('.site-header');
    if (!toggle || !header) return;
    var form = header.querySelector('.header__search');
    toggle.addEventListener('click', function () {
      var isOpen = header.classList.contains('is-search-open');
      if (isOpen) {
        header.classList.remove('is-search-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (form) {
          header.classList.add('is-search-closing');
          var done = function () { header.classList.remove('is-search-closing'); };
          var onEnd = function (e) { if (e.target !== form) return; form.removeEventListener('animationend', onEnd); done(); };
          form.addEventListener('animationend', onEnd);
          setTimeout(function () { form.removeEventListener('animationend', onEnd); done(); }, 360);
        }
      } else {
        header.classList.remove('is-search-closing');
        header.classList.add('is-search-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (form) {
          var input = form.querySelector('input[type="search"], input[name="q"], [data-predictive-input]');
          if (input) setTimeout(function () { input.focus(); }, 120);
        }
      }
    });
  }

  /* ---------- Bottom bar: Shop menu + Search popup ---------- */
  function setupBottomBarActions() {
    // Shop/Browse tab: multi-level browse panel on mobile, mega-menu on desktop
    var shopBtn = document.querySelector('[data-shop-toggle]');
    if (shopBtn) {
      var mega = document.querySelector('[data-shop-mega]');
      var browse = document.querySelector('[data-browse-panel]');
      function openMega() {
        if (!mega) return;
        mega.classList.add('is-open'); mega.setAttribute('aria-hidden', 'false');
        shopBtn.classList.add('is-active'); shopBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        setTimeout(updateMegaArrows, 30);
      }
      function closeMega() {
        if (!mega) return;
        mega.classList.remove('is-open'); mega.setAttribute('aria-hidden', 'true');
        shopBtn.classList.remove('is-active'); shopBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
      shopBtn.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 640px)').matches) {
          if (browse) { window.openBrowsePanel && window.openBrowsePanel(); }
          else if (typeof window.openDrawer === 'function') { window.openDrawer(); }
          else { var d = document.querySelector('[data-drawer-open]'); if (d) d.click(); }
        } else if (mega) {
          if (mega.classList.contains('is-open')) { closeMega(); } else { openMega(); }
        }
      });
      if (mega) {
        mega.querySelectorAll('[data-shop-mega-close]').forEach(function (c) {
          c.addEventListener('click', closeMega);
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });

        // Horizontal arrow scrolling for the category columns
        var megaTrack = mega.querySelector('[data-shop-mega-track]');
        var megaPrev = mega.querySelector('[data-shop-mega-prev]');
        var megaNext = mega.querySelector('[data-shop-mega-next]');
        function updateMegaArrows() {
          if (!megaTrack || !megaPrev || !megaNext) return;
          var overflow = megaTrack.scrollWidth - megaTrack.clientWidth > 8;
          if (!overflow) { megaPrev.classList.remove('is-visible'); megaNext.classList.remove('is-visible'); return; }
          var atStart = megaTrack.scrollLeft <= 4;
          var atEnd = megaTrack.scrollLeft + megaTrack.clientWidth >= megaTrack.scrollWidth - 4;
          megaPrev.classList.toggle('is-visible', !atStart);
          megaNext.classList.toggle('is-visible', !atEnd);
        }
        function megaScroll(dir) {
          if (!megaTrack) return;
          megaTrack.scrollBy({ left: dir * Math.round(megaTrack.clientWidth * 0.7), behavior: 'smooth' });
        }
        if (megaPrev) megaPrev.addEventListener('click', function () { megaScroll(-1); });
        if (megaNext) megaNext.addEventListener('click', function () { megaScroll(1); });
        if (megaTrack) megaTrack.addEventListener('scroll', updateMegaArrows);
        window.addEventListener('resize', updateMegaArrows);
      }
    }

    // Search tab: open the search popup and focus input
    var searchBtn = document.querySelector('[data-bb-search-toggle]');
    var pop = document.querySelector('[data-bb-search]');
    if (searchBtn && pop) {
      var input = pop.querySelector('input[type="search"]');
      function openSearch() {
        pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false');
        searchBtn.classList.add('is-active'); searchBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        if (input) setTimeout(function () { input.focus(); }, 60);
      }
      function closeSearch() {
        pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true');
        searchBtn.classList.remove('is-active'); searchBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
      searchBtn.addEventListener('click', function () {
        if (pop.classList.contains('is-open')) { closeSearch(); } else { openSearch(); }
      });
      pop.querySelectorAll('[data-bb-search-close]').forEach(function (c) {
        c.addEventListener('click', closeSearch);
      });
      // If the photo-search button inside the popup is tapped, close the popup so the photo modal shows on top
      var popPhoto = pop.querySelector('[data-photo-open]');
      if (popPhoto) {
        popPhoto.addEventListener('click', function () {
          pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true');
          searchBtn.classList.remove('is-active'); searchBtn.setAttribute('aria-expanded', 'false');
        });
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
    }

    // Account tab: open the account popup with up-arrow active state
    var accountBtn = document.querySelector('[data-bb-account-toggle]');
    var accPop = document.querySelector('[data-bb-account]');
    if (accountBtn && accPop) {
      function openAcc() {
        accPop.classList.add('is-open'); accPop.setAttribute('aria-hidden', 'false');
        accountBtn.classList.add('is-active'); accountBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
      function closeAcc() {
        accPop.classList.remove('is-open'); accPop.setAttribute('aria-hidden', 'true');
        accountBtn.classList.remove('is-active'); accountBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
      accountBtn.addEventListener('click', function () {
        if (accPop.classList.contains('is-open')) { closeAcc(); } else { openAcc(); }
      });
      accPop.querySelectorAll('[data-bb-account-close]').forEach(function (c) { c.addEventListener('click', closeAcc); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAcc(); });
    }
  }

  /* ---------- Voice search ---------- */
  function setupVoiceSearch() {
    var buttons = document.querySelectorAll('[data-voice-search]');
    if (!buttons.length) return;
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return; // unsupported browser — leave buttons hidden

    buttons.forEach(function (btn) {
      btn.hidden = false; // reveal now that we know it's supported
      var form = btn.closest('form');
      if (!form) return;
      var input = form.querySelector('input[type="search"], input[name="q"], [data-predictive-input]');
      if (!input) return;

      var recognition = new SR();
      recognition.lang = document.documentElement.lang || 'en-US';
      recognition.interimResults = true;
      recognition.maxAlternatives = 1;
      var listening = false;

      function setListening(on) {
        listening = on;
        btn.classList.toggle('is-listening', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }

      btn.addEventListener('click', function () {
        if (listening) { try { recognition.stop(); } catch (e) {} return; }
        try { recognition.start(); } catch (e) {}
      });

      recognition.addEventListener('start', function () { setListening(true); input.focus(); });
      recognition.addEventListener('end', function () { setListening(false); });
      recognition.addEventListener('error', function () { setListening(false); });

      recognition.addEventListener('result', function (e) {
        var transcript = '';
        for (var i = e.resultIndex; i < e.results.length; i++) {
          transcript += e.results[i][0].transcript;
        }
        transcript = transcript.replace(/[.?!]\s*$/, '').trim();
        input.value = transcript;
        // trigger predictive search as the text comes in
        input.dispatchEvent(new Event('input', { bubbles: true }));
        // when a final result arrives, submit the search
        var isFinal = e.results[e.results.length - 1].isFinal;
        if (isFinal && transcript) {
          setListening(false);
          try { recognition.stop(); } catch (err) {}
          if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
        }
      });
    });
  }

  /* ---------- Header search best sellers ---------- */
  function setupHeaderBest() {
    var panel = document.querySelector('[data-header-best]');
    if (!panel) return;
    var form = panel.closest('form');
    if (!form) return;
    var input = form.querySelector('input[type="search"], [data-predictive-input]');
    if (!input) return;

    function show() { if (input.value.trim().length === 0) panel.hidden = false; }
    function hide() { panel.hidden = true; }

    input.addEventListener('focus', show);
    input.addEventListener('input', function () {
      // hide best sellers as soon as the shopper types (predictive results take over)
      if (input.value.trim().length > 0) hide(); else show();
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }

  /* ---------- Admin edit link (reveal only with ?admin=1) ---------- */
  function setupAdminEdit() {
    var links = document.querySelectorAll('[data-admin-edit]');
    if (!links.length) return;
    var flag = false;
    try { flag = new URLSearchParams(window.location.search).get('admin') === '1'; } catch (e) {
      flag = /[?&]admin=1(&|$)/.test(window.location.search);
    }
    if (!flag) return;
    links.forEach(function (a) { a.hidden = false; });
  }

  /* ---------- Rotating search placeholder ---------- */
  function setupRotatingPlaceholder() {
    document.querySelectorAll('[data-rotate-placeholder]').forEach(function (input) {
      var prefix = input.getAttribute('data-rotate-prefix') || '';
      var raw = input.getAttribute('data-rotate-words') || '';
      var speed = parseInt(input.getAttribute('data-rotate-speed'), 10) || 2500;
      var words = raw.split(/[\n,]/).map(function (w) { return w.trim(); }).filter(Boolean).slice(0, 6);
      if (words.length === 0) return;
      var i = 0;
      var timer = null;
      function show() {
        input.classList.add('ph-fade');
        setTimeout(function () {
          input.setAttribute('placeholder', prefix + words[i]);
          i = (i + 1) % words.length;
          input.classList.remove('ph-fade');
        }, 180);
      }
      function start() { if (timer) return; show(); timer = setInterval(show, speed); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      // pause while focused/typing so it doesn't distract
      input.addEventListener('focus', stop);
      input.addEventListener('blur', function () { if (!input.value) start(); });
      start();
    });
  }

  /* ---------- Header notifications ---------- */
  function setupNotifications() {
    var wrap = document.querySelector('[data-notif]');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-notif-toggle]');
    var panel = wrap.querySelector('[data-notif-panel]');
    if (!btn || !panel) return;

    // Dismissed order notifications persist per browser
    var KEY = 'theme_dismissed_orders';
    var dismissed = [];
    try { dismissed = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { dismissed = []; }

    var dot = wrap.querySelector('[data-notif-dot]');
    function refreshBadge() {
      if (!dot) return;
      var visible = panel.querySelectorAll('.notif-item:not([hidden])').length;
      if (visible > 0) { dot.textContent = visible; dot.style.display = ''; }
      else { dot.style.display = 'none'; }
    }

    // Hide already-dismissed orders on load
    panel.querySelectorAll('[data-notif-order]').forEach(function (item) {
      var key = item.getAttribute('data-order-key');
      if (key && dismissed.indexOf(key) !== -1) item.hidden = true;
    });

    // Dismiss buttons
    panel.querySelectorAll('[data-notif-dismiss]').forEach(function (x) {
      x.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var key = x.getAttribute('data-order-key');
        var item = x.closest('.notif-item');
        if (item) item.hidden = true;
        if (key && dismissed.indexOf(key) === -1) {
          dismissed.push(key);
          try { localStorage.setItem(KEY, JSON.stringify(dismissed)); } catch (err) {}
        }
        refreshBadge();
      });
    });
    refreshBadge();

    function open() { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); btn.setAttribute('aria-expanded', 'true'); }
    function close() { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); if (panel.classList.contains('is-open')) close(); else open(); });
    wrap.querySelectorAll('[data-notif-close]').forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Food deal tier radios ---------- */
  function setupFoodTiers() {
    var form = document.querySelector('.fd__form');
    if (!form) return;
    var radios = form.querySelectorAll('[data-fd-tier]');
    var mirrors = form.querySelectorAll('[data-fd-mirror]');
    var variantInput = form.querySelector('[data-variant-id]');
    if (!radios.length) return;
    var dataEl = form.querySelector('[data-product-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var vid = radio.value;
        // visual selected state
        form.querySelectorAll('.fd__tier').forEach(function (t) { t.classList.remove('is-selected'); });
        var label = radio.closest('.fd__tier');
        if (label) label.classList.add('is-selected');
        // find variant + push its option values into mirror selects, then fire change
        var v = null;
        for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(vid)) { v = variants[i]; break; } }
        if (v && v.options) {
          mirrors.forEach(function (sel, idx) {
            if (v.options[idx] != null) { sel.value = v.options[idx]; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          });
        }
        // ensure hidden id is set even if no mirrors
        if (variantInput) variantInput.value = vid;
      });
    });
  }

  /* ---------- Daily deal tabs ---------- */
  function setupDdTabs() {
    document.querySelectorAll('[data-dd-tabs]').forEach(function (wrap) {
      var heads = wrap.querySelectorAll('[data-dd-tab]');
      var panes = wrap.querySelectorAll('[data-dd-pane]');
      heads.forEach(function (head) {
        head.addEventListener('click', function () {
          var id = head.getAttribute('data-dd-tab');
          heads.forEach(function (h) { h.classList.toggle('is-active', h === head); });
          panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-dd-pane') === id); });
        });
      });
    });
  }

  /* ---------- Deal design slider ---------- */
  function setupDealSlider() {
    document.querySelectorAll('[data-deal-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-deal-track]');
      var prev = slider.querySelector('[data-deal-prev]');
      var next = slider.querySelector('[data-deal-next]');
      if (!track) return;
      if (track.classList.contains('deal__row--grid')) return; // grid layout has no arrows
      function update() {
        var overflow = track.scrollWidth - track.clientWidth > 8;
        if (!overflow) { if (prev) prev.classList.remove('is-visible'); if (next) next.classList.remove('is-visible'); return; }
        var atStart = track.scrollLeft <= 4;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (prev) prev.classList.toggle('is-visible', !atStart);
        if (next) next.classList.toggle('is-visible', !atEnd);
      }
      function scroll(dir) { track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { scroll(-1); });
      if (next) next.addEventListener('click', function () { scroll(1); });
      track.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Browse panel (multi-level mobile menu) ---------- */
  function setupBrowsePanel() {
    var panel = document.querySelector('[data-browse-panel]');
    if (!panel) return;
    var sheet = panel.querySelector('.browse-panel__sheet');
    var levels = panel.querySelectorAll('[data-browse-level]');
    var backBtn = panel.querySelector('[data-browse-back]');
    var titleEl = panel.querySelector('[data-browse-title]');
    var rootTitle = titleEl ? titleEl.textContent : 'Browse';
    var stack = []; // history of {id, title}

    function showLevel(id, title, back) {
      panel.classList.toggle('browse-panel--back', !!back);
      // briefly fade the title text for a smoother label change
      if (titleEl) {
        titleEl.style.opacity = '0';
        setTimeout(function () { titleEl.textContent = title || rootTitle; titleEl.style.opacity = '1'; }, 130);
      }
      levels.forEach(function (lvl) { lvl.classList.toggle('is-active', lvl.getAttribute('data-browse-level') === id); });
      if (backBtn) backBtn.hidden = (id === 'root');
      var active = panel.querySelector('[data-browse-level].is-active');
      if (active) active.scrollTop = 0;
    }

    function open() {
      panel.classList.remove('browse-panel--back');
      // force reflow so the slide-up transition runs from translateY(100%)
      panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false');
      void panel.offsetWidth;
      document.body.style.overflow = 'hidden';
      stack = []; showLevel('root', rootTitle, false);
    }
    function close() {
      panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    window.openBrowsePanel = open;
    window.closeBrowsePanel = close;

    // "Scroll for more" arrow: scroll the root level down, hide when near bottom
    var scrollArrow = panel.querySelector('[data-browse-scroll]');
    if (scrollArrow) {
      var rootLevel = panel.querySelector('[data-browse-level="root"]');
      var scroller = rootLevel || sheet || panel;
      scrollArrow.addEventListener('click', function () {
        scroller.scrollBy({ top: Math.round(scroller.clientHeight * 0.7), behavior: 'smooth' });
      });
      var checkArrow = function () {
        var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 24;
        scrollArrow.classList.toggle('is-hidden', atBottom);
      };
      scroller.addEventListener('scroll', checkArrow, { passive: true });
      // re-check when panel opens
      var origOpen = window.openBrowsePanel;
      window.openBrowsePanel = function () { origOpen(); setTimeout(checkArrow, 60); };
    }

    // Drill into a level (forward)
    panel.querySelectorAll('[data-browse-go]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-browse-go');
        var heading = btn.getAttribute('data-browse-sub-heading');
        if (!heading) {
          var lvl = panel.querySelector('[data-browse-level="' + id + '"]');
          heading = lvl ? lvl.getAttribute('data-browse-heading') : '';
        }
        stack.push({ id: id, title: heading });
        showLevel(id, heading, false);
      });
    });

    // Back (reverse direction)
    if (backBtn) backBtn.addEventListener('click', function () {
      stack.pop();
      var prev = stack[stack.length - 1];
      showLevel(prev ? prev.id : 'root', prev ? prev.title : rootTitle, true);
    });

    panel.querySelectorAll('[data-browse-close]').forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
  }

  /* ---------- Cookie consent (GDPR) ---------- */
  function setupGdpr() {
    var banner = document.querySelector('[data-gdpr]');
    var reopen = document.querySelector('[data-gdpr-reopen]');
    if (!banner) return;

    var KEY = 'theme_cookie_consent_v2';
    var LEGACY = 'theme_cookie_consent';
    var prefs = banner.querySelector('[data-gdpr-prefs]');
    var customiseBtn = banner.querySelector('[data-gdpr-customise]');
    var cats = banner.querySelectorAll('[data-gdpr-cat]'); // analytics / marketing / preferences

    function read() {
      var raw;
      try { raw = localStorage.getItem(KEY); } catch (e) { raw = null; }
      if (raw) { try { return JSON.parse(raw); } catch (e) {} }
      // migrate legacy accepted/declined
      var old;
      try { old = localStorage.getItem(LEGACY); } catch (e) { old = null; }
      if (old === 'accepted') return { analytics: true, marketing: true, preferences: true };
      if (old === 'declined') return { analytics: false, marketing: false, preferences: false };
      return null;
    }

    function apply(c) {
      // Map our categories onto Shopify's Customer Privacy API
      try {
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
          Shopify.customerPrivacy.setTrackingConsent({
            analytics: !!c.analytics,
            marketing: !!c.marketing,
            preferences: !!c.preferences,
            sale_of_data: !!c.marketing
          }, function () {});
        }
      } catch (e) {}
    }

    function save(c) {
      try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
      apply(c);
    }

    function showBanner() { banner.hidden = false; if (reopen) reopen.hidden = true; }
    function hideBanner() { banner.hidden = true; if (reopen) reopen.hidden = false; }

    function openPrefs(open) {
      if (!prefs) return;
      prefs.hidden = !open;
      if (customiseBtn) customiseBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function fillToggles(c) {
      cats.forEach(function (input) {
        var k = input.getAttribute('data-gdpr-cat');
        input.checked = c ? !!c[k] : false;
      });
    }

    function collectToggles() {
      var c = { analytics: false, marketing: false, preferences: false };
      cats.forEach(function (input) { c[input.getAttribute('data-gdpr-cat')] = input.checked; });
      return c;
    }

    function finish(c) { save(c); openPrefs(false); hideBanner(); }

    // Wire buttons
    var acceptBtn = banner.querySelector('[data-gdpr-accept]');
    var rejectBtn = banner.querySelector('[data-gdpr-reject]');
    var saveBtn = banner.querySelector('[data-gdpr-save]');

    if (acceptBtn) acceptBtn.addEventListener('click', function () { finish({ analytics: true, marketing: true, preferences: true }); });
    if (rejectBtn) rejectBtn.addEventListener('click', function () { finish({ analytics: false, marketing: false, preferences: false }); });
    if (saveBtn) saveBtn.addEventListener('click', function () { finish(collectToggles()); });
    if (customiseBtn) customiseBtn.addEventListener('click', function () {
      openPrefs(prefs && prefs.hidden);
    });
    if (reopen) reopen.addEventListener('click', function () {
      fillToggles(read());
      showBanner();
      openPrefs(true);
    });

    // Initial state
    var existing = read();
    if (existing) {
      apply(existing);          // re-assert stored consent on every page load
      fillToggles(existing);
      hideBanner();             // banner stays hidden, reopen button visible
    } else {
      fillToggles(null);
      showBanner();             // first visit
    }
  }

  /* ---------- Country selector ---------- */
  function setupCountrySelect() {
    // Replace any flag image that fails to load (e.g. territories with no CDN flag) with a neutral globe
    var FALLBACK = "data:image/svg+xml;utf8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23889" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>');
    document.querySelectorAll('.country-select__flag-img').forEach(function (img) {
      function useFallback() {
        if (img.getAttribute('data-fallback') === '1') return;
        img.setAttribute('data-fallback', '1');
        img.src = FALLBACK;
        img.style.background = '#eef1f0';
      }
      img.addEventListener('error', useFallback);
      // Catch images that already failed before this script ran
      if (img.complete && img.naturalWidth === 0) useFallback();
    });

    var wraps = document.querySelectorAll('[data-country-select]');
    if (!wraps.length) return;
    wraps.forEach(function (wrap) {
      var toggle = wrap.querySelector('[data-country-toggle]');
      if (toggle) toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        // close any other open selectors
        wraps.forEach(function (w) { if (w !== wrap) w.classList.remove('is-open'); });
        wrap.classList.toggle('is-open');
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) wrap.classList.remove('is-open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') wraps.forEach(function (w) { w.classList.remove('is-open'); });
    });
  }

  /* ---------- Account dropdown (tap to open on touch) ---------- */
  function setupAccountMenu() {
    var menu = document.querySelector('[data-account-menu]');
    var toggle = document.querySelector('[data-account-toggle]');
    if (!menu || !toggle) return;

    // On touch devices the first tap opens the menu instead of navigating
    toggle.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && !menu.classList.contains('is-open')) {
        e.preventDefault();
        menu.classList.add('is-open');
      }
    });
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target)) menu.classList.remove('is-open');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu.classList.remove('is-open'); });
  }

  /* ---------- Deals slider (arrows + countdown) ---------- */
  function setupDeals() {
    var section = document.querySelector('[data-deals]');
    if (!section) return;

    var track = section.querySelector('[data-deals-track]');
    var prev = section.querySelector('[data-deals-prev]');
    var next = section.querySelector('[data-deals-next]');
    if (track && prev && next) {
      function step() { return Math.max(track.clientWidth * 0.85, 240); }
      function update() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev.addEventListener('click', function () { track.scrollLeft -= step(); });
      next.addEventListener('click', function () { track.scrollLeft += step(); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    var timer = section.querySelector('[data-deals-timer]');
    if (timer) {
      var clock = timer.querySelector('[data-deals-clock]');
      var deadlineAttr = timer.getAttribute('data-deadline');
      var deadline = deadlineAttr ? new Date(deadlineAttr).getTime() : NaN;
      if (!isNaN(deadline) && clock) {
        var DAY = 24 * 60 * 60 * 1000;
        function pad(n) { return (n < 10 ? '0' : '') + n; }
        function tick() {
          var now = Date.now();
          var remaining = deadline - now;
          // Once the deadline passes, roll forward in 24h cycles so it keeps counting
          if (remaining <= 0) {
            var cycles = Math.ceil((now - deadline) / DAY) || 1;
            deadline = deadline + cycles * DAY;
            remaining = deadline - now;
          }
          var totalSec = Math.floor(remaining / 1000);
          var h = Math.floor(totalSec / 3600);
          var m = Math.floor((totalSec % 3600) / 60);
          var s = totalSec % 60;
          clock.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
        }
        tick();
        setInterval(tick, 1000);
      } else if (clock) {
        timer.style.display = 'none';
      }
    }
  }

  /* ---------- Predictive search ---------- */
  function setupPredictiveSearch() {
    var forms = document.querySelectorAll('[data-predictive-search]');
    if (!forms.length) return;
    forms.forEach(function (form) {
    var input = form.querySelector('[data-predictive-input]');
    var results = form.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var timer = null;
    var brandTpl = form.querySelector('[data-search-branding-tpl]');
    var brandingHTML = brandTpl ? brandTpl.innerHTML : '';
    function withBranding(html) { return brandingHTML + html; }

    function hide() { results.hidden = true; results.innerHTML = ''; }

    function run(q) {
      results.hidden = false;
      results.innerHTML = '<div class="predictive__loading"><span class="spinner"></span></div>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { results.innerHTML = withBranding('<div class="predictive__empty">No matches for “' + escapeHtml(q) + '”</div>'); return; }
          results.innerHTML = withBranding(products.map(function (p) {
            var img = (p.image) || (p.featured_image && p.featured_image.url) || '';
            return '<a href="' + safeUrl(p.url) + '" class="predictive__item">' +
              '<span class="predictive__media">' + (img ? '<img src="' + safeUrl(img) + '" alt="">' : '') + '</span>' +
              '<span class="predictive__info"><span class="predictive__title">' + escapeHtml(p.title) + '</span>' +
              (p.price ? '<span class="predictive__price">' + formatMoney(typeof p.price === 'string' ? parseInt(p.price.replace(/[^0-9]/g, ''), 10) : p.price) + '</span>' : '') +
              '</span></a>';
          }).join('') + '<a href="/search?q=' + encodeURIComponent(q) + '" class="predictive__all">See all results</a>');
        })
        .catch(function () { hide(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { run(q); }, 250);
    });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false; });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    });
  }

  /* ---------- Quick view ---------- */
  function setupQuickView() {
    var modal = document.querySelector('[data-quickview-modal]');
    if (!modal) return;
    var content = modal.querySelector('[data-quickview-content]');

    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

    function load(handle) {
      content.innerHTML = '<div class="quickview__loading"><span class="spinner"></span></div>';
      open();
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) { render(p); })
        .catch(function () { content.innerHTML = '<p style="padding:24px">Sorry, this product could not be loaded. <a href="/products/' + encodeURIComponent(handle) + '" style="color:var(--color-teal)">View full page</a></p>'; });
    }

    function render(p) {
      var img = (p.featured_image) ? p.featured_image : (p.images && p.images[0]);
      var hasVariants = p.variants && p.variants.length > 1;
      var optionsHtml = '';
      if (hasVariants) {
        optionsHtml = '<select data-qv-variant class="qv__select">' + p.variants.map(function (v) {
          return '<option value="' + escapeHtml(v.id) + '"' + (v.available ? '' : ' disabled') + '>' + escapeHtml(v.title) + (v.available ? '' : ' — sold out') + '</option>';
        }).join('') + '</select>';
      }
      var firstId = (p.variants && p.variants[0]) ? p.variants[0].id : '';
      content.innerHTML =
        '<div class="qv">' +
          '<div class="qv__media"><img data-qv-image src="' + safeUrl(img || '') + '" alt=""' + (img ? '' : ' style="display:none"') + '></div>' +
          '<div class="qv__info">' +
            (p.vendor ? '<div class="qv__vendor">' + escapeHtml(p.vendor) + '</div>' : '') +
            '<h3 class="qv__title">' + escapeHtml(p.title) + '</h3>' +
            '<div class="qv__price" data-qv-price>' + formatMoney(p.price) + '</div>' +
            optionsHtml +
            '<button type="button" class="btn btn--primary btn--lg btn--block qv__add" data-qv-add data-id="' + escapeHtml(firstId) + '">Add to cart</button>' +
            '<a href="' + safeUrl(p.url) + '" class="qv__full">View full details</a>' +
          '</div>' +
        '</div>';

      var select = content.querySelector('[data-qv-variant]');
      var addBtn = content.querySelector('[data-qv-add]');
      var qvImg = content.querySelector('[data-qv-image]');
      var qvPrice = content.querySelector('[data-qv-price]');
      if (select) select.addEventListener('change', function () {
        addBtn.setAttribute('data-id', select.value);
        var v = null;
        for (var i = 0; i < p.variants.length; i++) { if (String(p.variants[i].id) === String(select.value)) { v = p.variants[i]; break; } }
        if (!v) return;
        // update price
        if (qvPrice) qvPrice.innerHTML = formatMoney(v.price);
        // resolve the variant image across the shapes Shopify returns
        var vimg = null;
        if (v.featured_image) {
          if (typeof v.featured_image === 'string') { vimg = v.featured_image; }
          else if (v.featured_image.src) { vimg = v.featured_image.src; }
        }
        if (!vimg && v.featured_media) {
          if (v.featured_media.preview_image && v.featured_media.preview_image.src) { vimg = v.featured_media.preview_image.src; }
          else if (v.featured_media.src) { vimg = v.featured_media.src; }
        }
        // last resort: match the variant's image id within the product images list
        if (!vimg && v.image_id && p.images && p.media) {
          for (var m = 0; m < p.media.length; m++) {
            if (p.media[m].id === v.image_id && p.media[m].preview_image) { vimg = p.media[m].preview_image.src; break; }
          }
        }
        if (qvImg && vimg) {
          // strip any width param so the swap is visible even if same base
          qvImg.src = vimg;
          qvImg.style.display = '';
        }
        // reflect availability on the button
        if (v.available) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
      });
      if (addBtn) addBtn.addEventListener('click', function () {
        var id = addBtn.getAttribute('data-id');
        if (!id) return;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function (r) { return r.json(); }).then(function () {
          close();
          if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
          else window.location.href = '/cart';
        }).catch(function () { addBtn.textContent = 'Add to cart'; });
      });
    }

    document.querySelectorAll('[data-quickview]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        load(btn.getAttribute('data-quickview'));
      });
    });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-quickview-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Back to top ---------- */
  function setupBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    function toggle() { btn.classList.toggle('is-visible', window.scrollY > 600); }
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  /* ---------- Announcement bar dismiss ---------- */
  function setupAnnouncement() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var id = bar.getAttribute('data-announcement-id');
    var key = 'announcement_dismissed_' + id;
    try { if (localStorage.getItem(key) === '1') { bar.style.display = 'none'; return; } } catch (e) {}
    var close = bar.querySelector('[data-announcement-close]');
    if (close) close.addEventListener('click', function () {
      bar.style.display = 'none';
      try { localStorage.setItem(key, '1'); } catch (e) {}
    });
  }

  /* ---------- Category cards slider ---------- */
  function setupCatSlider() {
    document.querySelectorAll('[data-cat-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-cat-track]');
      var prev = slider.querySelector('[data-cat-prev]');
      var next = slider.querySelector('[data-cat-next]');
      var prog = slider.querySelector('[data-cat-progress]');
      var bar = slider.querySelector('[data-cat-progress-bar]');
      if (!track) return;

      slider.classList.add('is-anim');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { slider.classList.add('is-ready'); io.disconnect(); } });
        }, { threshold: 0.12 });
        io.observe(slider);
      } else {
        slider.classList.add('is-ready');
      }

      // Cards wrap onto multiple rows: no arrows, progress or drag
      if (track.classList.contains('cat-cards__row--wrap')) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        if (prog) prog.style.display = 'none';
        return;
      }

      function step() { return Math.max(track.clientWidth * 0.8, 200); }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var overflowing = max > 4;
        slider.classList.toggle('is-scrollable', overflowing);
        if (!overflowing) return;
        var x = track.scrollLeft;
        if (prev) prev.classList.toggle('is-hidden', x <= 2);
        if (next) next.classList.toggle('is-hidden', x >= max - 2);
        if (bar) {
          var thumb = Math.max((track.clientWidth / track.scrollWidth) * 100, 12);
          var frac = max > 0 ? x / max : 0;
          bar.style.width = thumb + '%';
          bar.style.left = (frac * (100 - thumb)) + '%';
        }
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // Mouse drag-to-scroll (touch uses native momentum scrolling)
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = startLeft - dx;
      });
      function endDrag() { if (!down) return; down = false; track.classList.remove('is-dragging'); }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      // Progress scrubber (click / drag to scrub)
      if (prog) {
        var scrubbing = false;
        function scrubTo(clientX) {
          var r = prog.getBoundingClientRect();
          var f = Math.min(Math.max((clientX - r.left) / r.width, 0), 1);
          track.scrollLeft = f * (track.scrollWidth - track.clientWidth);
        }
        prog.addEventListener('pointerdown', function (e) { scrubbing = true; scrubTo(e.clientX); if (prog.setPointerCapture) prog.setPointerCapture(e.pointerId); });
        prog.addEventListener('pointermove', function (e) { if (scrubbing) scrubTo(e.clientX); });
        prog.addEventListener('pointerup', function () { scrubbing = false; });
        prog.addEventListener('pointercancel', function () { scrubbing = false; });
        prog.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { track.scrollBy({ left: step() * 0.5, behavior: 'smooth' }); e.preventDefault(); }
          else if (e.key === 'ArrowLeft') { track.scrollBy({ left: -step() * 0.5, behavior: 'smooth' }); e.preventDefault(); }
        });
      }

      update();
    });
  }

  /* ---------- Video section poster click-to-play ---------- */
  function setupVideo() {
    document.querySelectorAll('[data-video-embed]').forEach(function (poster) {
      poster.addEventListener('click', function () {
        var id = poster.getAttribute('data-video-embed');
        var type = poster.getAttribute('data-video-type');
        var src = type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
          : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        var wrap = poster.parentNode;
        wrap.innerHTML = '';
        wrap.appendChild(iframe);
      });
    });
  }

  /* ---------- Cart discount code ---------- */
  function setupDiscount() {
    var apply = document.querySelector('[data-discount-apply]');
    var input = document.querySelector('[data-discount-input]');
    if (!apply || !input) return;

    function go() {
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      // Shopify applies the code at checkout via the discount URL parameter
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }
    apply.addEventListener('click', go);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
  }

  /* ---------- Mobile facet toggle ---------- */
  function setupFacets() {
    var toggle = document.querySelector('[data-facets-toggle]');
    var panel = document.querySelector('[data-facets]');
    var backdrop = document.querySelector('[data-facets-backdrop]');
    var closeBtn = document.querySelector('[data-facets-close]');
    if (!toggle || !panel) return;

    function open() {
      panel.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      panel.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Sort change ---------- */
  function setupSort() {
    var sort = document.querySelector('[data-sort]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Favourite toggle (visual only) ---------- */
  /* ---------- Wishlist / favourites (browser storage) ---------- */
  var WISHLIST_KEY = 'theme_wishlist';

  function wishlistRead() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function wishlistWrite(obj) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(obj)); } catch (e) {}
    updateWishlistBadge();
  }
  function wishlistCount() { return Object.keys(wishlistRead()).length; }

  function updateWishlistBadge() {
    var n = wishlistCount();
    document.querySelectorAll('[data-wishlist-badge]').forEach(function (b) {
      b.textContent = n;
      b.style.display = n > 0 ? '' : 'none';
    });
  }

  function reflectFavState(btn, active) {
    var wasActive = btn.classList.contains('is-faved');
    btn.classList.toggle('is-faved', active);
    var svg = btn.querySelector('svg');
    if (svg) { svg.style.color = active ? '#d4380d' : ''; svg.setAttribute('fill', active ? 'currentColor' : 'none'); }
    var text = btn.querySelector('[data-fav-text]');
    if (text) text.textContent = active ? 'Saved to favourites' : 'Add to favourites';
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');

    // Update the visible count, preserving any surrounding format like "(3)"
    var countEl = btn.querySelector('[data-fav-count]');
    if (countEl && wasActive !== active) {
      if (countEl.getAttribute('data-base') === null) {
        var initial = countEl.textContent;
        countEl.setAttribute('data-base', (initial.match(/\d+/) || [0])[0]);
        countEl.setAttribute('data-paren', /\(/.test(initial) ? '1' : '0');
      }
      var base = parseInt(countEl.getAttribute('data-base'), 10) || 0;
      var shown = active ? base + 1 : base;
      countEl.textContent = countEl.getAttribute('data-paren') === '1' ? '(' + shown + ')' : shown;
    }
  }

  function setupFav() {
    var list = wishlistRead();

    document.querySelectorAll('[data-fav]').forEach(function (btn) {
      var handle = btn.getAttribute('data-fav-handle');
      if (handle && list[handle]) reflectFavState(btn, true);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var h = btn.getAttribute('data-fav-handle');
        if (!h) { // no product data (e.g. demo placeholder) -> visual only
          reflectFavState(btn, !btn.classList.contains('is-faved'));
          return;
        }
        var current = wishlistRead();
        if (current[h]) {
          delete current[h];
          reflectFavState(btn, false);
        } else {
          current[h] = {
            handle: h,
            title: btn.getAttribute('data-fav-title') || '',
            url: btn.getAttribute('data-fav-url') || ('/products/' + h),
            image: btn.getAttribute('data-fav-image') || '',
            price: btn.getAttribute('data-fav-price') || '',
            vendor: btn.getAttribute('data-fav-vendor') || '',
            added: Date.now()
          };
          reflectFavState(btn, true);
        }
        wishlistWrite(current);
        renderWishlistPage(); // refresh if we're on the wishlist page
      });
    });

    updateWishlistBadge();
    renderWishlistPage();
  }

  /* Human-friendly "time ago" with exact date/time on hover */
  function relativeTime(ts) {
    var diff = Math.floor((Date.now() - ts) / 1000);
    var label;
    if (diff < 60) label = 'just now';
    else if (diff < 3600) { var m = Math.floor(diff / 60); label = m + (m === 1 ? ' minute ago' : ' minutes ago'); }
    else if (diff < 86400) { var h = Math.floor(diff / 3600); label = h + (h === 1 ? ' hour ago' : ' hours ago'); }
    else if (diff < 604800) { var d = Math.floor(diff / 86400); label = d + (d === 1 ? ' day ago' : ' days ago'); }
    else {
      var date = new Date(ts);
      label = 'on ' + date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
    }
    var full = new Date(ts).toLocaleString();
    return '<span title="' + full + '">' + label + '</span>';
  }

  /* Render saved items into a wishlist page container, if present */
  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var store = wishlistRead();
    var items = Object.keys(store)
      .map(function (k) { return store[k]; })
      .filter(function (p) { return p && (p.handle || p.url); }); // skip malformed entries
    items.sort(function (a, b) { return (b.added || 0) - (a.added || 0); });

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    grid.innerHTML = items.map(function (p) {
      return '' +
        '<article class="card">' +
          '<a href="' + safeUrl(p.url) + '" class="card__media">' +
            (p.image ? '<img src="' + safeUrl(p.image) + '" alt="" loading="lazy">' : '') +
            '<button type="button" class="card__fav is-faved" data-fav data-fav-handle="' + escapeHtml(p.handle) + '" ' +
              'data-fav-title="' + escapeHtml(p.title || '') + '" data-fav-url="' + escapeHtml(p.url) + '" ' +
              'data-fav-image="' + escapeHtml(p.image) + '" data-fav-price="' + escapeHtml(p.price || '') + '" data-fav-vendor="' + escapeHtml(p.vendor || '') + '" ' +
              'aria-label="Remove from favourites" aria-pressed="true">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" style="color:#d4380d"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>' +
            '</button>' +
          '</a>' +
          '<div class="card__body"><a href="' + safeUrl(p.url) + '">' +
            (p.vendor ? '<div class="card__brand">' + escapeHtml(p.vendor) + '</div>' : '') +
            '<div class="card__title">' + escapeHtml(p.title || '') + '</div>' +
            (p.price ? '<div class="card__price">' + escapeHtml(p.price) + '</div>' : '') +
          '</a>' +
            (p.added ? '<div class="card__added">Added ' + relativeTime(p.added) + '</div>' : '') +
          '</div>' +
        '</article>';
    }).join('');

    // Re-bind the newly rendered hearts so removing works
    grid.querySelectorAll('[data-fav]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var h = btn.getAttribute('data-fav-handle');
        var current = wishlistRead();
        delete current[h];
        wishlistWrite(current);
        renderWishlistPage();
        // also un-fav any matching hearts elsewhere on the page
        document.querySelectorAll('[data-fav-handle="' + h + '"]').forEach(function (other) {
          if (other !== btn) reflectFavState(other, false);
        });
      });
    });
  }

  /* ---------- Recently viewed ---------- */
  var RECENT_KEY = 'theme_recently_viewed';
  function recentRead() { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; } }
  function recentWrite(arr) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, 20))); } catch (e) {} }

  /* ---------- Gift options (wrap + message) ---------- */
  /* ---------- Sticky add-to-cart bar ---------- */
  function setupStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    // Find the real product form + its add button on the page
    var form = document.querySelector('[data-product-form]') || document.querySelector('form[action*="/cart/add"]');
    var realAdd = form ? form.querySelector('[name="add"], button[type="submit"]') : null;
    var addBtn = bar.querySelector('[data-sticky-add]');

    // Show the bar only once you've scrolled PAST the buy button (it's above the viewport),
    // not while it's still below the fold.
    var anchor = realAdd || document.querySelector('[data-buy]');
    if (anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // Visible → hide the sticky bar
          if (e.isIntersecting) { bar.classList.remove('is-visible'); return; }
          // Not visible: show only if the button is above the viewport (scrolled past),
          // hide if it's still below (not reached yet).
          if (e.boundingClientRect.top < 0) { bar.classList.add('is-visible'); }
          else { bar.classList.remove('is-visible'); }
        });
      }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });
      io.observe(anchor);
    } else {
      // Fallback: show only after the button's position has been scrolled past
      window.addEventListener('scroll', function () {
        var rect = anchor ? anchor.getBoundingClientRect() : null;
        if (rect && rect.bottom < 0) bar.classList.add('is-visible'); else bar.classList.remove('is-visible');
      }, { passive: true });
    }

    // Clicking the sticky button adds to cart via AJAX (falls back to clicking the real button)
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (typeof window.ajaxAddToCart === 'function') { window.ajaxAddToCart(); }
        else if (realAdd) { realAdd.click(); }
      });
    }

    // Sticky variant selectors mirror to the real form's <select> (so existing variant logic runs)
    var realSelects = form ? Array.prototype.slice.call(form.querySelectorAll('[data-option-index]')) : [];
    bar.querySelectorAll('[data-sticky-opt-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-sticky-opt-index'), 10);
      var sel = realSelects[idx];
      // Swatch buttons
      group.querySelectorAll('[data-sticky-val]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-sticky-val');
          group.querySelectorAll('[data-sticky-val]').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
          if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });
      // Dropdown select
      var stickySelect = group.querySelector('[data-sticky-select]');
      if (stickySelect) {
        stickySelect.addEventListener('change', function () {
          if (sel) { sel.value = stickySelect.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }
    });
    // Keep sticky selectors in sync if the real selects change elsewhere
    realSelects.forEach(function (sel, idx) {
      sel.addEventListener('change', function () {
        var group = bar.querySelector('[data-sticky-opt-index="' + idx + '"]');
        if (!group) return;
        group.querySelectorAll('[data-sticky-val]').forEach(function (b) {
          b.classList.toggle('is-selected', b.getAttribute('data-sticky-val') === sel.value);
        });
        var stickySelect = group.querySelector('[data-sticky-select]');
        if (stickySelect && stickySelect.value !== sel.value) stickySelect.value = sel.value;
      });
    });

    // Keep sticky price in sync if the page updates the main price (variant change)
    var mainPrice = document.querySelector('[data-price]');
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    if (mainPrice && stickyPrice && 'MutationObserver' in window) {
      new MutationObserver(function () { stickyPrice.textContent = mainPrice.textContent; })
        .observe(mainPrice, { childList: true, characterData: true, subtree: true });
    }

    // Keep the sticky thumbnail in sync with the selected variant's image (works on all product layouts)
    var stickyImg = bar.querySelector('[data-sticky-img]');
    var dataEl2 = document.querySelector('[data-product-variants]');
    var variants2 = null;
    if (dataEl2) { try { variants2 = JSON.parse(dataEl2.textContent); } catch (e) {} }
    if (stickyImg && variants2 && realSelects.length) {
      var syncStickyImg = function () {
        var chosen = realSelects.map(function (s) { return s.value; });
        var match = variants2.find(function (v) {
          return v.options && v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (match && match.image) stickyImg.src = match.image;
      };
      realSelects.forEach(function (s) { s.addEventListener('change', syncStickyImg); });
    }
  }

  function setupGiftOptions() {
    document.querySelectorAll('[data-gift-options]').forEach(function (box) {
      var textarea = box.querySelector('textarea');
      var count = box.querySelector('[data-gift-count]');
      var wrapCb = box.querySelector('[data-gift-wrap]');
      var msgWrap = box.querySelector('[data-gift-message-wrap]');
      // Char counter
      if (textarea && count) {
        var upd = function () { count.textContent = textarea.value.length; };
        textarea.addEventListener('input', upd);
        upd();
      }
      // Reveal message box only when gift wrap is ticked (if configured hidden)
      if (wrapCb && msgWrap && msgWrap.hasAttribute('hidden')) {
        wrapCb.addEventListener('change', function () {
          if (wrapCb.checked) { msgWrap.removeAttribute('hidden'); }
          else { msgWrap.setAttribute('hidden', ''); if (textarea) { textarea.value = ''; if (count) count.textContent = '0'; } }
        });
      }
    });
  }

  function trackRecentlyViewed() {    // Only run on product pages
    var isProduct = document.body.classList.contains('template-product') ||
                    /\/products\//.test(window.location.pathname);
    if (!isProduct) return;
    // Find any fav button on the page (works across all product templates)
    var src = document.querySelector('[data-fav][data-fav-handle]');
    if (!src) return;
    var handle = src.getAttribute('data-fav-handle');
    if (!handle) return;
    var entry = {
      handle: handle,
      title: src.getAttribute('data-fav-title') || '',
      url: src.getAttribute('data-fav-url') || ('/products/' + handle),
      image: src.getAttribute('data-fav-image') || '',
      price: src.getAttribute('data-fav-price') || '',
      vendor: src.getAttribute('data-fav-vendor') || '',
      viewed: Date.now()
    };
    var list = recentRead().filter(function (p) { return p.handle !== handle; });
    list.unshift(entry);
    recentWrite(list);
  }

  function rvCardHtml(p) {
    return '' +
      '<article class="card card--natural">' +
        '<a href="' + safeUrl(p.url) + '" class="card__media">' +
          (p.image ? '<img src="' + safeUrl(p.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="card__body"><a href="' + safeUrl(p.url) + '">' +
          (p.vendor ? '<div class="card__brand">' + escapeHtml(p.vendor) + '</div>' : '') +
          '<div class="card__title">' + escapeHtml(p.title || '') + '</div>' +
          (p.price ? '<div class="card__price">' + escapeHtml(p.price) + '</div>' : '') +
        '</a></div>' +
      '</article>';
  }

  function renderRecentlyViewed() {
    var grid = document.querySelector('[data-recently-grid]');
    if (grid) {
      var empty = document.querySelector('[data-recently-empty]');
      var items = recentRead().filter(function (p) { return p && (p.handle || p.url); });
      if (!items.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; }
      else { if (empty) empty.hidden = true; grid.innerHTML = items.map(rvCardHtml).join(''); }
    }
    // Horizontal recently-viewed row (home/product)
    document.querySelectorAll('[data-rv-row-grid]').forEach(function (rowGrid) {
      var section = rowGrid.closest('[data-rv-row]');
      var limit = parseInt(rowGrid.getAttribute('data-rv-limit'), 10) || 10;
      var exclude = rowGrid.getAttribute('data-rv-exclude');
      var list = recentRead().filter(function (p) { return p && (p.handle || p.url); });
      if (exclude) list = list.filter(function (p) { return p.handle !== exclude; });
      list = list.slice(0, limit);
      if (!list.length) { if (section) section.hidden = true; return; }
      if (section) section.hidden = false;
      rowGrid.innerHTML = list.map(rvCardHtml).join('');
    });
  }

  /* ---------- Image cards row ---------- */
  function setupImgCards() {
    document.querySelectorAll('[data-imgcards]').forEach(function (sec) {
      var row = sec.querySelector('[data-imgcards-row]');
      var prev = sec.querySelector('[data-imgcards-prev]');
      var next = sec.querySelector('[data-imgcards-next]');
      if (!row) return;
      function update() {
        var overflow = row.scrollWidth - row.clientWidth > 8;
        if (!overflow) { if (prev) prev.hidden = true; if (next) next.hidden = true; return; }
        if (prev) prev.hidden = row.scrollLeft <= 4;
        if (next) next.hidden = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      }
      function scroll(d) { row.scrollBy({ left: d * Math.round(row.clientWidth * 0.8), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { scroll(-1); });
      if (next) next.addEventListener('click', function () { scroll(1); });
      row.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- FAQ page (search + category filter) ---------- */
  function setupFaqPage() {
    var root = document.querySelector('[data-faqx]');
    if (!root) return;
    var search = root.querySelector('[data-faqx-search]');
    var tabs = root.querySelectorAll('[data-faqx-filter]');
    var items = root.querySelectorAll('[data-faqx-item]');
    var groups = root.querySelectorAll('[data-faqx-group]');
    var noResults = root.querySelector('[data-faqx-noresults]');
    var activeCat = 'all';

    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var anyVisible = false;
      items.forEach(function (item) {
        var cat = item.getAttribute('data-faqx-cat');
        var qt = (item.querySelector('[data-faqx-qtext]') || {}).textContent || '';
        var at = (item.querySelector('[data-faqx-atext]') || {}).textContent || '';
        var matchCat = activeCat === 'all' || cat === activeCat;
        var matchText = q === '' || (qt + ' ' + at).toLowerCase().indexOf(q) !== -1;
        var show = matchCat && matchText;
        item.style.display = show ? '' : 'none';
        if (show) anyVisible = true;
        if (q !== '' && matchText && show) { item.open = true; } else if (q === '') { item.open = false; }
      });
      // hide empty groups
      groups.forEach(function (g) {
        var visible = g.querySelectorAll('[data-faqx-item]');
        var has = false;
        visible.forEach(function (it) { if (it.style.display !== 'none') has = true; });
        g.style.display = has ? '' : 'none';
      });
      if (noResults) noResults.hidden = anyVisible;
    }

    if (search) search.addEventListener('input', apply);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        activeCat = tab.getAttribute('data-faqx-filter');
        apply();
      });
    });
  }

  /* ---------- FAQ page end ---------- */
  function setupCatTiles() {
    document.querySelectorAll('[data-cattiles]').forEach(function (sec) {
      var row = sec.querySelector('[data-cattiles-row]');
      var prev = sec.querySelector('[data-cattiles-prev]');
      var next = sec.querySelector('[data-cattiles-next]');
      if (!row) return;
      function update() {
        var overflow = row.scrollWidth - row.clientWidth > 8;
        if (!overflow) { if (prev) prev.hidden = true; if (next) next.hidden = true; return; }
        var atStart = row.scrollLeft <= 4;
        var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
        if (prev) prev.hidden = atStart;
        if (next) next.hidden = atEnd;
      }
      function scroll(dir) { row.scrollBy({ left: dir * Math.round(row.clientWidth * 0.8), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { scroll(-1); });
      if (next) next.addEventListener('click', function () { scroll(1); });
      row.addEventListener('scroll', update);
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Lookbook hotspots ---------- */
  function setupLookbook() {
    document.querySelectorAll('.lookbook').forEach(function (lb) {
      var dots = lb.querySelectorAll('[data-lookbook-dot]');
      var pops = lb.querySelectorAll('[data-lookbook-pop]');
      function closeAll() {
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        pops.forEach(function (p) { p.classList.remove('is-open'); });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          var pop = pops[i];
          var wasOpen = pop && pop.classList.contains('is-open');
          closeAll();
          if (pop && !wasOpen) { pop.classList.add('is-open'); dot.classList.add('is-active'); }
        });
      });
      document.addEventListener('click', function (e) { if (!lb.contains(e.target)) closeAll(); });
      lb.querySelector('.lookbook__image-wrap') && lb.querySelector('.lookbook__image-wrap').addEventListener('click', function (e) {
        if (!e.target.closest('[data-lookbook-dot]') && !e.target.closest('[data-lookbook-pop]')) closeAll();
      });
    });
  }

  /* ---------- Swipeable card image carousel ---------- */
  function setupCardSwipe() {
    document.querySelectorAll('[data-card-swipe]').forEach(function (media) {
      var track = media.querySelector('[data-card-swipe-track]');
      var dots = media.parentNode.querySelectorAll('.card__dot');
      if (!track) return;
      // prevent the card link navigating when the shopper is swiping
      var startX = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { startX = e.clientX; moved = false; });
      track.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - startX) > 6) moved = true; });
      media.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } });
      if (dots.length) {
        track.addEventListener('scroll', function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === Math.min(idx, dots.length - 1)); });
        });
      }
    });
  }

  /* ---------- Product countdown ---------- */
  function setupCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var endStr = el.getAttribute('data-countdown-end');
      var end = new Date(endStr.replace(' ', 'T')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var timer = el.querySelector('[data-countdown-timer]');
      var ended = el.querySelector('[data-countdown-ended]');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (timer) timer.style.display = 'none';
          if (ended) ended.hidden = false;
          clearInterval(iv);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var parts = [];
        if (d > 0) parts.push(d + 'd');
        parts.push(('0' + h).slice(-2) + 'h');
        parts.push(('0' + m).slice(-2) + 'm');
        parts.push(('0' + s).slice(-2) + 's');
        if (timer) timer.textContent = parts.join(' ');
      }
      tick();
      var iv = setInterval(tick, 1000);
    });
  }

  /* ---------- Size guide modal ---------- */
  function setupSizeGuide() {
    var modal = document.querySelector('[data-sizeguide-modal]');
    if (!modal) return;
    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    document.querySelectorAll('[data-sizeguide-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    modal.querySelectorAll('[data-sizeguide-close]').forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Related products (Complete the look) ---------- */
  function setupRelated() {
    document.querySelectorAll('[data-related]').forEach(function (sec) {
      var url = sec.getAttribute('data-related-url');
      var grid = sec.querySelector('[data-related-grid]');
      if (!url || !grid) return; // already server-rendered or using a collection
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.related__grid');
          if (inner && inner.children.length) { grid.innerHTML = inner.innerHTML; }
          else { var wrap = sec.closest('.container'); if (wrap) wrap.style.display = 'none'; }
        })
        .catch(function () { var wrap = sec.closest('.container'); if (wrap) wrap.style.display = 'none'; });
    });
  }

  /* ---------- Search by photo ---------- */
  function setupPhotoSearch() {
    var modal = document.querySelector('[data-photo-modal]');
    if (!modal) return;

    var input = modal.querySelector('[data-photo-input]');
    var drop = modal.querySelector('[data-photo-drop]');
    var prompt = modal.querySelector('[data-photo-prompt]');
    var preview = modal.querySelector('[data-photo-preview]');
    var controls = modal.querySelector('[data-photo-controls]');
    var swatch = modal.querySelector('[data-photo-swatch]');
    var colourLabel = modal.querySelector('[data-photo-colour]');
    var detectedRow = modal.querySelector('[data-photo-detected]');
    var hintEl = modal.querySelector('[data-photo-hint]');
    var keyword = modal.querySelector('[data-photo-keyword]');
    var resultsEl = modal.querySelector('[data-photo-results]');
    var statusEl = modal.querySelector('[data-photo-status]');
    var endpoint = window.themeVisualSearchEndpoint || '';
    var currentFile = null;
    var detectedColour = '';

    // Set hint copy based on mode
    if (hintEl) {
      hintEl.textContent = endpoint
        ? 'Drag an image here or tap to choose. We\u2019ll find visually similar items.'
        : 'Drag an image here or tap to choose. We\u2019ll match items by colour.';
    }

    // Named colour palette for nearest-match
    var PALETTE = [
      ['black', 0, 0, 0], ['white', 245, 245, 245], ['grey', 128, 128, 128],
      ['navy', 20, 30, 70], ['blue', 40, 90, 200], ['teal', 0, 128, 128],
      ['green', 40, 140, 60], ['olive', 110, 110, 50], ['red', 200, 40, 40],
      ['pink', 235, 150, 175], ['purple', 120, 60, 160], ['orange', 230, 130, 40],
      ['yellow', 230, 210, 60], ['brown', 110, 70, 40], ['beige', 220, 205, 175],
      ['cream', 245, 238, 220]
    ];

    function nearestColour(r, g, b) {
      var best = '', bestD = Infinity;
      PALETTE.forEach(function (p) {
        var d = (r - p[1]) * (r - p[1]) + (g - p[2]) * (g - p[2]) + (b - p[3]) * (b - p[3]);
        if (d < bestD) { bestD = d; best = p[0]; }
      });
      return best;
    }

    function dominantColour(img) {
      var size = 64;
      var canvas = document.createElement('canvas');
      canvas.width = size; canvas.height = size;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, size, size);
      var data;
      try { data = ctx.getImageData(0, 0, size, size).data; } catch (e) { return null; }
      var buckets = {};
      for (var i = 0; i < data.length; i += 4) {
        var r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
        if (a < 125) continue;
        var lum = 0.299 * r + 0.587 * g + 0.114 * b;
        if (lum > 240 || lum < 12) continue; // skip near-white bg & near-black
        var key = (r >> 5) + '-' + (g >> 5) + '-' + (b >> 5);
        if (!buckets[key]) buckets[key] = { n: 0, r: 0, g: 0, b: 0 };
        buckets[key].n++; buckets[key].r += r; buckets[key].g += g; buckets[key].b += b;
      }
      var top = null;
      Object.keys(buckets).forEach(function (k) { if (!top || buckets[k].n > top.n) top = buckets[k]; });
      if (!top) return [200, 200, 200];
      return [Math.round(top.r / top.n), Math.round(top.g / top.n), Math.round(top.b / top.n)];
    }

    function handleFile(file) {
      if (!file || !/^image\//.test(file.type)) return;
      currentFile = file;
      var reader = new FileReader();
      reader.onload = function (e) {
        preview.src = e.target.result;
        preview.hidden = false;
        prompt.style.display = 'none';
        if (endpoint) {
          // Visual API mode: colour detection is irrelevant
          if (detectedRow) detectedRow.hidden = true;
          controls.hidden = false;
        } else {
          var img = new Image();
          img.onload = function () {
            var rgb = dominantColour(img) || [200, 200, 200];
            detectedColour = nearestColour(rgb[0], rgb[1], rgb[2]);
            swatch.style.background = 'rgb(' + rgb.join(',') + ')';
            colourLabel.textContent = detectedColour;
            if (detectedRow) detectedRow.hidden = false;
            controls.hidden = false;
          };
          img.src = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    }

    function card(p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      var price = p.price != null ? (typeof p.price === 'string' ? p.price : formatMoney(p.price)) : '';
      return '' +
        '<article class="card"><a href="' + safeUrl(p.url) + '" class="card__media">' +
        (img ? '<img src="' + safeUrl(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="card__body"><a href="' + safeUrl(p.url) + '">' +
        (p.vendor ? '<div class="card__brand">' + escapeHtml(p.vendor) + '</div>' : '') +
        '<div class="card__title">' + escapeHtml(p.title || '') + '</div>' +
        (price ? '<div class="card__price">' + escapeHtml(price) + '</div>' : '') +
        '</a></div></article>';
    }

    function setStatus(msg) {
      if (!msg) { statusEl.hidden = true; statusEl.innerHTML = ''; return; }
      statusEl.hidden = false; statusEl.innerHTML = msg;
    }

    function renderResults(products) {
      if (!products || !products.length) {
        resultsEl.innerHTML = '';
        setStatus('No matches found. Try a different photo or add a keyword.');
        return;
      }
      setStatus('');
      resultsEl.innerHTML = products.map(card).join('');
    }

    function searchByColour() {
      var q = [detectedColour, (keyword.value || '').trim()].filter(Boolean).join(' ');
      if (!q) return;
      setStatus('<span class="spinner"></span>Finding matches for “' + escapeHtml(q) + '”…');
      resultsEl.innerHTML = '';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products);
        })
        .catch(function () { setStatus('Something went wrong. Please try again.'); });
    }

    function normaliseProduct(p) {
      // Accept a range of field names different providers may return
      return {
        title: p.title || p.name || p.product_title || '',
        url: p.url || p.handle && ('/products/' + p.handle) || p.link || '#',
        featured_image: p.featured_image || null,
        image: p.image || p.image_url || p.thumbnail || (p.images && p.images[0]) || '',
        vendor: p.vendor || p.brand || '',
        price: (p.price != null ? p.price : (p.price_min != null ? p.price_min : null))
      };
    }

    function searchByEndpoint() {
      setStatus('<span class="spinner"></span>Analysing your photo…');
      resultsEl.innerHTML = '';
      var fd = new FormData();
      fd.append('image', currentFile);
      if (keyword.value) fd.append('keyword', keyword.value.trim());

      fetch(endpoint, { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          // Accept { products: [...] }, { results: [...] }, or a bare array
          var list = data.products || data.results || data.items || (Array.isArray(data) ? data : []);
          var products = (list || []).map(normaliseProduct).filter(function (p) { return p.url && p.url !== '#'; });
          if (!products.length) {
            setStatus('No visual matches found. Try a clearer photo of a single item, or add a keyword.');
            return;
          }
          renderResults(products);
        })
        .catch(function (err) {
          // Don't silently show colour-based (wrong) results — be honest about the failure.
          setStatus('Couldn\'t reach the visual search service. Please try again in a moment.');
        });
    }

    function runSearch() {
      if (!currentFile) return;
      if (endpoint) searchByEndpoint(); else searchByColour();
    }

    function reset() {
      currentFile = null; detectedColour = '';
      preview.hidden = true; preview.src = '';
      prompt.style.display = '';
      controls.hidden = true;
      if (detectedRow) detectedRow.hidden = true;
      resultsEl.innerHTML = ''; setStatus('');
      keyword.value = ''; input.value = '';
    }

    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

    document.querySelectorAll('[data-photo-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        // Close the browse panel first so the photo modal isn't hidden behind it
        if (typeof window.closeBrowsePanel === 'function') window.closeBrowsePanel();
        open();
      });
    });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-photo-close]')) { if (typeof stopCamera === 'function') stopCamera(); close(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) { if (typeof stopCamera === 'function') stopCamera(); close(); } });

    input.addEventListener('change', function () { handleFile(input.files[0]); });
    // "Upload photo" button → opens the file picker
    var uploadBtn = modal.querySelector('[data-photo-upload-btn]');
    if (uploadBtn) uploadBtn.addEventListener('click', function (e) { e.preventDefault(); input.click(); });

    // "Take photo" → live camera (desktop webcam / mobile camera), fallback to file input
    var cameraBtn = modal.querySelector('[data-photo-camera-btn]');
    var cameraInput = modal.querySelector('[data-photo-camera-input]');
    var camView = modal.querySelector('[data-photo-camera-view]');
    var video = modal.querySelector('[data-photo-video]');
    var camCapture = modal.querySelector('[data-photo-camera-capture]');
    var camCancel = modal.querySelector('[data-photo-camera-cancel]');
    var camSwitch = modal.querySelector('[data-photo-camera-switch]');
    var actions = modal.querySelector('[data-photo-actions]');
    var drop = modal.querySelector('[data-photo-drop]');
    var stream = null;
    var facing = 'environment';

    function stopCamera() {
      if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; }
      if (camView) camView.hidden = true;
    }
    function startCamera() {
      // No support → fall back to the native file/camera input
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        if (cameraInput) cameraInput.click();
        return;
      }
      navigator.mediaDevices.getUserMedia({ video: { facingMode: facing }, audio: false })
        .then(function (s) {
          stream = s;
          if (video) { video.srcObject = s; }
          if (camView) camView.hidden = false;
          if (drop) drop.hidden = true;
          if (actions) actions.hidden = true;
          // Show flip button if more than one camera (mostly phones)
          if (camSwitch && navigator.mediaDevices.enumerateDevices) {
            navigator.mediaDevices.enumerateDevices().then(function (ds) {
              var cams = ds.filter(function (d) { return d.kind === 'videoinput'; });
              camSwitch.hidden = cams.length < 2;
            });
          }
        })
        .catch(function () {
          // Permission denied or no camera → fall back to file input
          if (cameraInput) cameraInput.click();
        });
    }
    function closeCamera() {
      stopCamera();
      if (drop) drop.hidden = false;
      if (actions) actions.hidden = false;
    }
    if (cameraBtn) cameraBtn.addEventListener('click', function (e) { e.preventDefault(); startCamera(); });
    if (camCancel) camCancel.addEventListener('click', function () { closeCamera(); });
    if (camSwitch) camSwitch.addEventListener('click', function () {
      facing = (facing === 'environment') ? 'user' : 'environment';
      stopCamera(); startCamera();
    });
    if (camCapture) camCapture.addEventListener('click', function () {
      if (!video || !video.videoWidth) return;
      var canvas = document.createElement('canvas');
      canvas.width = video.videoWidth; canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      canvas.toBlob(function (blob) {
        if (blob) {
          var file = new File([blob], 'camera-photo.jpg', { type: 'image/jpeg' });
          closeCamera();
          handleFile(file);
        }
      }, 'image/jpeg', 0.9);
    });
    // Native file/camera input (fallback path) → same handler
    if (cameraInput) cameraInput.addEventListener('change', function () { handleFile(cameraInput.files[0]); });
    modal.querySelector('[data-photo-search]').addEventListener('click', runSearch);
    keyword.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); runSearch(); } });
    modal.querySelector('[data-photo-reset]').addEventListener('click', function (e) { e.preventDefault(); reset(); });

    // Drag & drop
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
    });
  }
  function setupCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return; // feature disabled -> icon link navigates normally

    var backdrop = document.querySelector('[data-cart-backdrop]');
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var loadingEl = drawer.querySelector('[data-cart-loading]');

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    function busy(on) {
      if (loadingEl) loadingEl.classList.toggle('is-busy', !!on);
      // Show skeleton placeholders only when there's nothing rendered yet
      if (on && itemsEl && !itemsEl.querySelector('.cd-item')) {
        var rows = '';
        for (var i = 0; i < 3; i++) {
          rows += '<div class="cd-skeleton"><span class="cd-skeleton__media"></span>' +
            '<span class="cd-skeleton__lines"><span></span><span></span><span></span></span></div>';
        }
        itemsEl.innerHTML = rows;
      }
    }

    function updateCounts(count) {
      // Drawer's own count label, e.g. "Your cart (2)"
      var c = drawer.querySelector('[data-cart-count]');
      if (c) c.textContent = '(' + count + ')';
      // Header cart badge(s) — target the cart icon's badge specifically.
      // Exclude the bottom bar bag (it has its own badge handled below).
      var cartIcons = document.querySelectorAll('[data-cart-toggle]:not(.bottom-bar__item), .header__cart');
      cartIcons.forEach(function (icon) {
        var badge = icon.querySelector('.header__count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__count';
            badge.setAttribute('data-cart-count', '');
            icon.appendChild(badge);
          }
          badge.textContent = count;
          badge.style.display = '';
        } else if (badge) {
          badge.style.display = 'none';
        }
      });
      // Bottom bar bag badge if present
      var bbBadge = document.querySelector('[data-bb-cart-count]');
      if (bbBadge) {
        bbBadge.textContent = count;
        bbBadge.style.display = count > 0 ? '' : 'none';
      }
    }

    function render(cart) {
      if (cart.item_count === 0) {
        itemsEl.innerHTML =
          '<div class="cart-drawer__empty"><p>Your cart is empty.</p>' +
          '<a href="/collections/all" class="btn btn--primary" data-cart-close>Start shopping</a></div>';
        if (footEl) footEl.hidden = true;
      } else {
        var rows = cart.items.map(function (item) {
          var img = item.image || (item.featured_image && item.featured_image.url) || '';
          var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? ' · ' + escapeHtml(item.variant_title) : '';
          var showVendor = window.themeCartShowVendor !== false;
          var brandLine = (showVendor && item.vendor) ? '<div class="cd-item__brand">' + escapeHtml(item.vendor) + '</div>' : '';
          return '' +
            '<div class="cd-item" data-key="' + escapeHtml(item.key) + '">' +
              '<a href="' + safeUrl(item.url) + '" class="cd-item__media">' + (img ? '<img src="' + safeUrl(img) + '" alt="">' : '') + '</a>' +
              '<div class="cd-item__info">' +
                brandLine +
                '<div class="cd-item__title">' + escapeHtml(item.product_title) + variant + '</div>' +
                '<div class="cd-item__controls">' +
                  '<div class="qty">' +
                    '<button type="button" data-cd-minus aria-label="Decrease">−</button>' +
                    '<input type="text" value="' + item.quantity + '" data-cd-qty readonly aria-label="Quantity">' +
                    '<button type="button" data-cd-plus aria-label="Increase">+</button>' +
                  '</div>' +
                  '<button type="button" class="cd-item__remove" data-cd-remove>Remove</button>' +
                '</div>' +
              '</div>' +
              '<div class="cd-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>';
        }).join('');
        itemsEl.innerHTML = rows;
        if (footEl) {
          footEl.hidden = false;
          var sub = footEl.querySelector('[data-cart-subtotal]');
          var tot = footEl.querySelector('[data-cart-total]');
          if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);
          if (tot) tot.textContent = formatMoney(cart.total_price);
        }
      }
      updateCounts(cart.item_count);
      updateFreeShip(cart);
      updateCartGoal(cart);
    }

    function barUpdate(bar, cfg, cart, msgSel, fillSel) {
      if (!bar || !cfg.enabled || !cfg.threshold || cfg.threshold <= 0) return;
      if (cart.item_count === 0) { bar.hidden = true; return; }
      bar.hidden = false;
      var subtotal = cart.items_subtotal_price;
      var remaining = cfg.threshold - subtotal;
      var msg = bar.querySelector(msgSel);
      var fill = bar.querySelector(fillSel);
      var pct = Math.min(100, Math.round((subtotal / cfg.threshold) * 100));
      if (fill) fill.style.width = pct + '%';
      if (remaining <= 0) {
        bar.classList.add('is-complete');
        if (msg) msg.textContent = cfg.successText || '';
      } else {
        bar.classList.remove('is-complete');
        var tpl = cfg.progressText || 'Spend [amount] more';
        if (msg) msg.textContent = tpl.replace('[amount]', formatMoney(remaining));
      }
    }

    function updateCartGoal(cart) {
      barUpdate(drawer.querySelector('[data-cart-goal]'), window.themeCartGoal || {}, cart, '[data-cart-goal-msg]', '[data-cart-goal-fill]');
    }

    function updateFreeShip(cart) {
      var cfg = window.themeFreeShip || {};
      var bar = drawer.querySelector('[data-free-ship]');
      if (!bar || !cfg.enabled || !cfg.threshold || cfg.threshold <= 0) return;
      if (cart.item_count === 0) { bar.hidden = true; return; }
      bar.hidden = false;

      var subtotal = cart.items_subtotal_price;
      var remaining = cfg.threshold - subtotal;
      var msg = bar.querySelector('[data-free-ship-msg]');
      var fill = bar.querySelector('[data-free-ship-fill]');
      var pct = Math.min(100, Math.round((subtotal / cfg.threshold) * 100));
      if (fill) fill.style.width = pct + '%';

      if (remaining <= 0) {
        bar.classList.add('is-complete');
        if (msg) msg.textContent = cfg.successText || "You've unlocked free shipping!";
      } else {
        bar.classList.remove('is-complete');
        var tpl = cfg.progressText || 'Spend [amount] more for free shipping';
        if (msg) msg.textContent = tpl.replace('[amount]', formatMoney(remaining));
      }
    }

    function refresh(thenOpen) {
      busy(true);
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          try { render(cart); } catch (err) {}
          if (thenOpen) open();
          busy(false);
        })
        .catch(function () { busy(false); if (thenOpen) open(); });
    }

    function change(key, quantity) {
      busy(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { try { render(cart); } catch (err) {} busy(false); })
        .catch(function () { busy(false); });
    }

    // Open from header cart icon
    document.querySelectorAll('[data-cart-toggle]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
    });

    // Close interactions
    if (backdrop) backdrop.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Quantity + remove (event delegation)
    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('.cd-item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var input = row.querySelector('[data-cd-qty]');
      var current = parseInt(input ? input.value : '1', 10) || 1;
      if (e.target.closest('[data-cd-plus]')) change(key, current + 1);
      else if (e.target.closest('[data-cd-minus]')) change(key, Math.max(0, current - 1));
      else if (e.target.closest('[data-cd-remove]')) change(key, 0);
    });

    // Intercept add-to-cart on product page (only the "add" button)
    var pform = document.querySelector('[data-product-form]');
    function ajaxAddFromForm(theForm) {
      busy(true);
      var data = new FormData(theForm);
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:added')); return refresh(true); })
        .catch(function () { theForm.submit(); });
    }
    if (pform) {
      pform.addEventListener('submit', function (e) {
        var submitter = e.submitter || document.activeElement;
        if (!submitter || submitter.name !== 'add') return; // let "Buy now" go to checkout
        e.preventDefault();
        ajaxAddFromForm(pform);
      });
    }
    // Shared add used by the sticky bar (so it uses AJAX, not a page nav)
    window.ajaxAddToCart = function () {
      var f = document.querySelector('[data-product-form]');
      if (f) ajaxAddFromForm(f);
    };

    // Expose so other handlers could open it if needed
    window.openCartDrawer = function () { refresh(true); };
  }
  function setupShip() {
    document.querySelectorAll('[data-ship]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        document.querySelectorAll('[data-ship]').forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        var radio = opt.querySelector('input[type=radio]');
        if (radio) radio.checked = true;
      });
    });
  }

  /* ---------- Mega menu (master-detail) ---------- */
  function setupMegaMenu() {
    document.querySelectorAll('.mega-md').forEach(function (md) {
      var rails = md.querySelectorAll('[data-md-rail]');
      var panes = md.querySelectorAll('[data-md-pane]');
      if (!rails.length || !panes.length) return;

      function activate(index) {
        rails.forEach(function (r) {
          var on = r.getAttribute('data-md-rail') === index;
          r.classList.toggle('is-active', on);
          r.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-md-pane') === index);
        });
      }

      rails.forEach(function (rail) {
        var index = rail.getAttribute('data-md-rail');
        rail.addEventListener('mouseenter', function () { activate(index); });
        rail.addEventListener('focus', function () { activate(index); });
        rail.addEventListener('click', function (e) { e.preventDefault(); activate(index); });
      });

      // Reset to the first category whenever the menu is reopened
      var catItem = md.closest('.cat-item');
      if (catItem) {
        catItem.addEventListener('mouseleave', function () {
          if (rails[0]) activate(rails[0].getAttribute('data-md-rail'));
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupDrawer();
    setupMegaMenu();
    setupAccordions();
    setupGallery();
    setupVariants();
    setupPd2Swatches();
    setupZoom();
    setupQty();
    setupFacets();
    setupAccountMenu();
    setupCountrySelect();
    setupBottomBarActions();
    setupVoiceSearch();
    setupHeaderBest();
    setupDealSlider();
    setupDdTabs();
    setupFoodTiers();
    setupNotifications();
    setupRotatingPlaceholder();
    setupAdminEdit();
    trackRecentlyViewed();
    renderRecentlyViewed();
    setupGiftOptions();
    setupStickyAtc();
    setupRelated();
    setupSizeGuide();
    setupCountdown();
    setupCardSwipe();
    setupLookbook();
    setupCatTiles();
    setupFaqPage();
    setupImgCards();
    setupBrowsePanel();
    setupGdpr();
    setupMobileSearch();
    setupCardHoverVideo();
    setupDiscount();
    setupVideo();
    setupCatSlider();
    setupAnnouncement();
    setupBackToTop();
    setupQuickView();
    setupPredictiveSearch();
    setupDeals();
    setupSort();
    setupFav();
    setupShip();
    setupCartDrawer();
    setupPhotoSearch();
  });
})();

/* HighStreetly logo hover: letters do a shopper's hop in sequence, an awning
   stripe rolls out underneath, and the HS bag pops up beside the wordmark. */
(function () {
  function initLogoLove() {
    var logo = document.querySelector('.header__logo');
    if (!logo || logo.dataset.hsWave) return;
    logo.dataset.hsWave = '1';
    var main = logo.querySelector('.header__logo-main') || logo;
    if (main.querySelector('img, svg, video')) { logo.classList.add('hs-logo--media'); return; }
    var text = main.textContent;
    if (!text || !text.trim()) return;
    var frag = document.createDocumentFragment(), idx = 0;
    text.split('').forEach(function (ch) {
      if (ch.trim() === '') { frag.appendChild(document.createTextNode('\u00A0')); return; }
      var sp = document.createElement('span');
      sp.className = 'hs-logo-ch';
      sp.style.setProperty('--i', idx++);
      sp.textContent = ch;
      frag.appendChild(sp);
    });
    main.textContent = '';
    main.appendChild(frag);
    logo.classList.add('hs-logo--wave');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLogoLove);
  else initLogoLove();
})();

/* Courier rides across the cart drawer whenever an item lands in the bag */
document.addEventListener('cart:added', function () {
  var cc = document.querySelector('[data-cart-courier]');
  if (!cc || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  cc.classList.remove('is-riding'); void cc.offsetWidth;
  setTimeout(function () { cc.classList.add('is-riding'); }, 350);
  setTimeout(function () { cc.classList.remove('is-riding'); }, 2600);
});
